import {useQuery, UseQueryOptions} from "@tanstack/react-query";
import {useImproveAxios} from "@/app2/shared/hooks/useImproveAxios";
import {getImproveAPI, ListCohortsResponse} from "@/app2/shared/data/gen";

/**
 * Hook for fetching publicly visible cohorts
 * 
 * Used by the CohortLibraryImportModal to display available cohorts.
 * Fetches all publicly visible cohorts in a single request.
 */
export const useGetCohorts = (
	options?: UseQueryOptions<ListCohortsResponse, Error>,
) => {
	const axiosConfig = useImproveAxios();
	const {cohortsControllerList} = getImproveAPI();

	return useQuery<ListCohortsResponse, Error>({
		queryKey: ["cohorts", "list", "public"],
		queryFn: async () => {
			const response = await cohortsControllerList(
				{
					pageSize: 200, // Fetch all publicly visible cohorts
					orderDirection: "asc"
				},
				axiosConfig,
			);
			return response.data;
		},
		staleTime: 5 * 60 * 1000, // 5 minutes
		...options
	});
};

